import React from 'react';
import { IconButton } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { iconButtonStyles } from '../styles/NavBarStyles';

export const LogoutButton = ({ onLogout }) => {
  return (
    <IconButton color="inherit" onClick={onLogout} sx={iconButtonStyles}>
      <LogoutIcon />
    </IconButton>
  );
};
